import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Stack,
  TextField,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";
import { ToastError } from "../../../utils/Toaster/Toaster";
import Styles from "../TaskDetails.module.scss";
import { jwtDecode } from "jwt-decode";

import {
  formatDisplayDate,
  formatDisplayTime,
  calculateDuration,
} from "../utils/helpers";
import { VERIFY_STATUS, ISSUETYPE } from "../../../common/constant/constant";
import { useAuth } from "../../../context/AuthProvider";
import { getTokenbyData } from "../../../services/user.service";
const WorkLogs = ({
  workLogsData,
  historyData,
  selectedData,
  onUpdateWorkLogs,
  task,
  updateTaskData,
  isAdmin,
}) => {
  // console.log(isAdmin, "selectedData");
  // console.log(workLogsData, "workLogsData");
  console.log("sele", selectedData);
  console.log("taskkk", task);
  // console.log("updatedd", updateTaskData);
  // console.log("onnnnnn", onUpdateWorkLogs);
  const { accessToken } = useAuth();
  const [workLogs, setWorkLogs] = useState(workLogsData || []);
  const [editingWorkLog, setEditingWorkLog] = useState(null);
  const [editDate, setEditDate] = useState(null);
  const [editStartTime, setEditStartTime] = useState(null);
  const [editEndTime, setEditEndTime] = useState(null);
  const [isAddingWorkLog, setIsAddingWorkLog] = useState(false);
  const [newWorkLogDate, setNewWorkLogDate] = useState(null);
  const [newWorkLogStartTime, setNewWorkLogStartTime] = useState(null);
  const [newWorkLogEndTime, setNewWorkLogEndTime] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [workLogIdToDelete, setWorkLogIdToDelete] = useState(null);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);

  const isBugOrTask = [ISSUETYPE.BUG, ISSUETYPE.TASK].includes(
    selectedData?.issueType
  );
  // //const userName = localStorage.getItem("name");
  // const role = localStorage.getItem("role");
  useEffect(() => {
    // console.log("Received new workLogsData prop:", workLogsData);
    setWorkLogs(workLogsData);
  }, [workLogsData]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTokenbyData();
        // console.log("ressss", res);
        const usersData = res.data;
        const userId = usersData?.userId;
        // console.log("userrrrr", userId);
        const userName = usersData?.name;
        const userRole = usersData?.role;
        const isAdmin = usersData?.isOverAllAdmin || false;
        const isClient = usersData?.isClient || false;
        setUserId(userId);
        setRole(userRole);
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchData();
  }, []);
  const getUserIdFromToken = () => {
    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const handleEditWorkLog = (workLog) => {
    // console.log("ass by", workLog.assignedBy);
    // console.log("ass to", workLog.assignedTo);
    setEditingWorkLog(workLog._id);
    setEditDate(dayjs(workLog.date));
    setEditStartTime(dayjs(workLog.startTime));
    setEditEndTime(dayjs(workLog.endTime));
  };

  const handleSaveWorkLog = async (workLogId) => {
    if (!editDate || !editStartTime || !editEndTime) {
      ToastError("Please fill all fields");
      return;
    }

    if (editEndTime.isBefore(editStartTime)) {
      ToastError("End time cannot be before start time");
      return;
    }

    const updatedWorkLogs = workLogs.map((log) => {
      if (log._id === workLogId) {
        return {
          ...log,
          date: editDate.toISOString(),
          startTime: editStartTime.toISOString(),
          endTime: editEndTime.toISOString(),
          assignedTo: selectedData?.assignedTo || null,
        };
      }
      return log;
    });

    // console.log("Sending updatedWorkLogs from EDIT:", updatedWorkLogs);
    try {
      await updateTaskData({
        workLog: JSON.parse(JSON.stringify(updatedWorkLogs)),
      });
      setEditingWorkLog(null);
      setEditDate(null);
      setEditStartTime(null);
      setEditEndTime(null);
    } catch (error) {
      console.error("Failed to update work log:", error);
    }
  };

  const handleCancelEditWorkLog = () => {
    setEditingWorkLog(null);
    setEditDate(null);
    setEditStartTime(null);
    setEditEndTime(null);
  };

  const handleAddWorkLog = () => {
    setIsAddingWorkLog(true);
    setNewWorkLogDate(dayjs());
    setNewWorkLogStartTime(dayjs().startOf("hour"));
    setNewWorkLogEndTime(dayjs().startOf("hour").add(1, "hour"));
  };

  const handleSaveNewWorkLog = async () => {
    if (!newWorkLogDate || !newWorkLogStartTime || !newWorkLogEndTime) {
      ToastError("Please fill all fields");
      return;
    }

    if (newWorkLogEndTime.isBefore(newWorkLogStartTime)) {
      ToastError("End time cannot be before start time");
      return;
    }

    const newWorkLog = {
      date: newWorkLogDate.toISOString(),
      startTime: newWorkLogStartTime.toISOString(),
      endTime: newWorkLogEndTime.toISOString(),
      assignedBy: userId,
      assignedTo: selectedData?.assignedTo || null,
    };

    if (selectedData?.verifyStatus === VERIFY_STATUS.REOPEN) {
      newWorkLog.verifyStatus = VERIFY_STATUS.REOPEN;
    } else if (selectedData?.clientVerifyStatus === VERIFY_STATUS.REOPEN) {
      newWorkLog.clientVerifyStatus = VERIFY_STATUS.REOPEN;
    }
    // const updatedWorkLogs = [...workLogs, newWorkLog];
    const updatedWorkLogs = [
      ...workLogs.map((log) => ({
        ...log,
        assignedBy: log.assignedBy, // preserve original
        assignedTo: log.assignedTo, // preserve original
      })),
      {
        ...newWorkLog,
        assignedBy: userId, // current logged-in user
        assignedTo: selectedData?.assignedTo || null,
      },
    ];
    console.log(updatedWorkLogs, "updatedWorkLogs");
    try {
      const responce = await updateTaskData({
        workLog: JSON.parse(JSON.stringify(updatedWorkLogs)),
      });
      console.log("responnnnn", responce);
      if (responce) {
        setIsAddingWorkLog(false);
        setNewWorkLogDate(null);
        setNewWorkLogStartTime(null);
        setNewWorkLogEndTime(null);
      }
    } catch (error) {
      console.error("Failed to add work log:", error);
    }
  };

  const handleCancelAddWorkLog = () => {
    setIsAddingWorkLog(false);
    setNewWorkLogDate(null);
    setNewWorkLogStartTime(null);
    setNewWorkLogEndTime(null);
  };

  const handleClickOpenDeleteDialog = (id) => {
    setWorkLogIdToDelete(id);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setWorkLogIdToDelete(null);
    setDeleteDialogOpen(false);
  };

  const handleDeleteWorkLog = async () => {
    const updatedWorkLogs = workLogs.filter(
      (log) => log._id !== workLogIdToDelete
    );
    console.log("Sending updatedWorkLogs from DELETE:", updatedWorkLogs);
    try {
      await updateTaskData({
        workLog: JSON.parse(JSON.stringify(updatedWorkLogs)),
      });
      handleCloseDeleteDialog();
    } catch (error) {
      console.error("Failed to delete work log:", error);
    }
  };

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#181818",
          fontWeight: 700,
          mb: 2,
        }}
      >
        Work Logs
      </Typography>

      {isAddingWorkLog && (
        <Paper sx={{ p: 2, mb: 2, border: "1px solid #e0e0e0" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Add New Work Log
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <DatePicker
                  label="Date"
                  value={newWorkLogDate}
                  onChange={setNewWorkLogDate}
                  // minDate={dayjs()}
                  // maxDate={dayjs()}
                  disabled={!(role == 1 || role == 5)}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TimePicker
                  label="Start Time"
                  value={newWorkLogStartTime}
                  onChange={setNewWorkLogStartTime}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TimePicker
                  label="End Time"
                  value={newWorkLogEndTime}
                  onChange={setNewWorkLogEndTime}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
            <Button
              className={Styles.commentSaveBtn}
              size="small"
              onClick={handleSaveNewWorkLog}
            >
              Save
            </Button>
            <Button size="small" onClick={handleCancelAddWorkLog}>
              Cancel
            </Button>
          </Stack>
        </Paper>
      )}

      {!isAddingWorkLog && (isBugOrTask || isAdmin) && (
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddWorkLog}
          className={Styles.commentSaveBtn}
          sx={{ mb: 2, minWidth: "170px" }}
        >
          Add Work Log
        </Button>
      )}

      {workLogs?.length > 0 ? (
        <>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <TableContainer
              component={Paper}
              sx={{ border: "1px solid #e0e0e0", maxHeight: "350px", overflowY: "auto" }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: 1, backgroundColor: "#fafafa" }}>
                      <strong>Assignee</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 1, backgroundColor: "#fafafa" }}>
                      <strong>Date</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 1, backgroundColor: "#fafafa" }}>
                      <strong>Start Time</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 1, backgroundColor: "#fafafa" }}>
                      <strong>End Time</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 1, backgroundColor: "#fafafa" }}>
                      <strong>Duration</strong>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ padding: 1, verticalAlign: "middle", backgroundColor: "#fafafa" }}
                    >
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workLogs.map((workLog) => (
                    <TableRow
                      key={workLog._id}
                      sx={{
                        "& td": {
                          color:
                            workLog?.assignedTo !== workLog?.assignedBy
                              ? "red"
                              : "inherit",
                          fontWeight: workLog.assignedTo !== userId ? 600 : 400,
                        },
                      }}
                    >
                      {editingWorkLog === workLog._id ? (
                        <>
                          <TableCell sx={{ padding: 2 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Date"
                                value={editDate}
                                onChange={setEditDate}
                                disabled={!(role == 1 || role == 5)}
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth size="small" />
                                )}
                              />
                            </LocalizationProvider>
                          </TableCell>
                          <TableCell>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="Start Time"
                                value={editStartTime}
                                onChange={setEditStartTime}
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth size="small" />
                                )}
                              />
                            </LocalizationProvider>
                          </TableCell>
                          <TableCell>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="End Time"
                                value={editEndTime}
                                onChange={setEditEndTime}
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth size="small" />
                                )}
                              />
                            </LocalizationProvider>
                          </TableCell>
                          <TableCell></TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1}>
                              <Button
                                className={Styles.commentSaveBtn}
                                size="small"
                                onClick={() => handleSaveWorkLog(workLog._id)}
                              >
                                Save
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1}>
                              <Button
                                className={Styles.commentCancelBtn}
                                size="small"
                                onClick={handleCancelEditWorkLog}
                              >
                                Cancel
                              </Button>
                            </Stack>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell sx={{ padding: 1 }}>
                            {workLog.assignedToName
                              ? workLog.assignedToName
                              : "N/A"}
                          </TableCell>
                          <TableCell sx={{ padding: 1 }}>
                            {formatDisplayDate(workLog.date)}
                          </TableCell>
                          <TableCell sx={{ padding: 1 }}>
                            {formatDisplayTime(workLog.startTime)}
                          </TableCell>
                          <TableCell sx={{ padding: 1 }}>
                            {formatDisplayTime(workLog.endTime)}
                          </TableCell>
                          <TableCell sx={{ padding: 1 }}>
                            {calculateDuration(workLog.startTime, workLog.endTime)}
                          </TableCell>
                          <TableCell align="center" sx={{ padding: 1 }}>
                            <Stack
                              direction="row"
                              spacing={1}
                              justifyContent="center"
                            >
                              {/* Edit Button: Visible if Admin OR (AssignedTo is User AND Date is Today) */}
                              {(isAdmin ||
                                (workLog.assignedTo === userId &&
                                  dayjs(workLog.date).isSame(dayjs(), "day"))) && (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleEditWorkLog(workLog)}
                                    color="primary"
                                  >
                                    <EditIcon />
                                  </IconButton>
                                )}

                              {/* Delete Button: Visible if Admin OR AssignedTo is User */}
                              {(isAdmin || workLog.assignedTo === userId &&
                                dayjs(workLog.date).isSame(dayjs(), "day")) && (isBugOrTask || isAdmin) && (
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleClickOpenDeleteDialog(workLog._id)
                                    }
                                    color="error"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                            </Stack>
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Mobile View */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Stack spacing={1.5}>
              {workLogs.map((workLog) => (
                <Paper
                  key={workLog._id}
                  sx={{
                    p: 1.5,
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    position: "relative",
                  }}
                >
                  {editingWorkLog === workLog._id ? (
                    <Stack spacing={1.5}>
                      <Typography variant="subtitle2" fontWeight={600}>
                        Edit Work Log
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Date"
                          value={editDate}
                          onChange={setEditDate}
                          disabled={!(role == 1 || role == 5)}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth size="small" />
                          )}
                        />
                        <Stack direction="row" spacing={1}>
                          <TimePicker
                            label="Start Time"
                            value={editStartTime}
                            onChange={setEditStartTime}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth size="small" />
                            )}
                          />
                          <TimePicker
                            label="End Time"
                            value={editEndTime}
                            onChange={setEditEndTime}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth size="small" />
                            )}
                          />
                        </Stack>
                      </LocalizationProvider>
                      <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button
                          className={Styles.commentCancelBtn}
                          size="small"
                          onClick={handleCancelEditWorkLog}
                        >
                          Cancel
                        </Button>
                        <Button
                          className={Styles.commentSaveBtn}
                          size="small"
                          onClick={() => handleSaveWorkLog(workLog._id)}
                        >
                          Save
                        </Button>
                      </Stack>
                    </Stack>
                  ) : (
                    <Stack spacing={1}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="caption" color="textSecondary">
                          Assignee
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          color={
                            workLog?.assignedTo !== workLog?.assignedBy
                              ? "red"
                              : "inherit"
                          }
                        >
                          {workLog.assignedToName || "N/A"}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="caption" color="textSecondary">
                          Date
                        </Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {formatDisplayDate(workLog.date)}
                        </Typography>
                      </Box>
                      <Box display="flex" gap={2}>
                        <Box flex={1}>
                          <Typography variant="caption" color="textSecondary">
                            Start
                          </Typography>
                          <Typography variant="body2">
                            {formatDisplayTime(workLog.startTime)}
                          </Typography>
                        </Box>
                        <Box flex={1}>
                          <Typography variant="caption" color="textSecondary">
                            End
                          </Typography>
                          <Typography variant="body2">
                            {formatDisplayTime(workLog.endTime)}
                          </Typography>
                        </Box>
                        <Box flex={1}>
                          <Typography variant="caption" color="textSecondary">
                            Duration
                          </Typography>
                          <Typography variant="body2">
                            {calculateDuration(workLog.startTime, workLog.endTime)}
                          </Typography>
                        </Box>
                      </Box>
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ mt: 0.5, borderTop: "1px solid #f0f0f0", pt: 1 }}
                      >
                        {(isAdmin ||
                          (workLog.assignedTo === userId &&
                            dayjs(workLog.date).isSame(dayjs(), "day"))) && (
                            <IconButton
                              size="small"
                              onClick={() => handleEditWorkLog(workLog)}
                              color="primary"
                              sx={{ p: 0.5 }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          )}
                        {(isAdmin || workLog.assignedTo === userId) && isBugOrTask && (
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleClickOpenDeleteDialog(workLog._id)
                            }
                            color="error"
                            sx={{ p: 0.5 }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Stack>
                    </Stack>
                  )}
                </Paper>
              ))}
            </Stack>
          </Box>
        </>
      ) : (
        !isAddingWorkLog && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: "center", py: 3 }}
          >
            No work logs found. Click "Add Work Log" to create one.
          </Typography>
        )
      )}

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this work log? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog}>Cancel</Button>
          <Button onClick={handleDeleteWorkLog} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* {workLogs?.length > 0 ? (
        <Stack spacing={2}>
          {workLogs.map((workLog) => (
            <Paper key={workLog._id} sx={{ p: 2, border: "1px solid #e0e0e0" }}>
              {editingWorkLog === workLog._id ? (
                <>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Edit Work Log
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <DatePicker
                          label="Date"
                          value={dayjs()}
                          onChange={() => {}}
                          minDate={dayjs()}
                          maxDate={dayjs()}
                          disabled
                          renderInput={(params) => (
                            <TextField {...params} fullWidth disabled />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TimePicker
                          label="Start Time"
                          value={editStartTime}
                          onChange={setEditStartTime}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TimePicker
                          label="End Time"
                          value={editEndTime}
                          onChange={setEditEndTime}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </LocalizationProvider>
                  <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                    <Button
                      className={Styles.commentSaveBtn}
                      size="small"
                      onClick={() => handleSaveWorkLog(workLog._id)}
                    >
                      Save
                    </Button>
                    <Button size="small" onClick={handleCancelEditWorkLog}>
                      Cancel
                    </Button>
                  </Stack>
                </>
              ) : (
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Date
                    </Typography>
                    <Typography variant="body2">
                      {formatDisplayDate(workLog.date)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Start Time
                    </Typography>
                    <Typography variant="body2">
                      {formatDisplayTime(workLog.startTime)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      End Time
                    </Typography>
                    <Typography variant="body2">
                      {formatDisplayTime(workLog.endTime)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Duration
                    </Typography>
                    <Typography variant="body2">
                      {calculateDuration(workLog.startTime, workLog.endTime)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <Stack direction="row" spacing={1}>
                      <IconButton
                        size="small"
                        onClick={() => handleEditWorkLog(workLog)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteWorkLog(workLog._id)}
                        color="black"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </Paper>
          ))}
        </Stack>
      ) : (
        !isAddingWorkLog && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: "center", py: 3 }}
          >
            No work logs found. Click "Add Work Log" to create one.
          </Typography>
        )
      )} */}
    </Box>
  );
};

export default WorkLogs;
